module.exports = __webpack_public_path__ + "img/plus1.e75ac424.png";